module.exports = __webpack_public_path__ + "static/media/iphone1.c73dcd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iphone1.jpg
// module id = 412
// module chunks = 1